import { NgModule } from '@angular/core';

import { HomeRoutingModule } from './home.routing';
import { WelcomeComponent } from './welcome/welcome.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [WelcomeComponent],
  imports: [SharedModule, HomeRoutingModule]
})
export class HomeModule {}
